import React from "react";
import { Container } from "react-bootstrap";
import { FaTools, FaClock } from "react-icons/fa";
import "../styles/MaintenancePage.css";

const MaintenancePage = () => {
  return (
    <Container fluid className="maintenance-page">
      <div className="maintenance-content">
        <div className="maintenance-icon">
          <FaTools />
        </div>
        <h1>İşleri Daha İyi Hale Getiriyoruz!</h1>
        <p className="maintenance-message">
          Ekibimiz, size daha iyi bir deneyim sunmak için sıkı çalışıyor.
          Verdiğimiz rahatsızlık için özür dileriz ve sabrınız için teşekkür
          ederiz.
        </p>
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
        <div className="estimated-time">
          <FaClock className="clock-icon" />
          <p>Tahmini tamamlanma süresi: 1 Hafta</p>
        </div>
        <div className="maintenance-features">
          <div className="feature">
            <span className="feature-dot"></span>
            <p>Sistem Güncellemeleri</p>
          </div>
          <div className="feature">
            <span className="feature-dot"></span>
            <p>Performans İyileştirmeleri</p>
          </div>
          <div className="feature">
            <span className="feature-dot"></span>
            <p>Gelişmiş Güvenlik</p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default MaintenancePage;
